import React from 'react';
import * as Progress from '@radix-ui/react-progress';

type ProgressBarProps = {
	value: number;
}

export const ProgressBar = ({ value }: ProgressBarProps) => {
	if (!value) {
		return null;
	}

	return (
		<Progress.Root className="relative bg-progress-bar-background w-full h-1 will-change-transform" value={value}>
			<Progress.Indicator className="w-full h-full bg-progress-bar-completed rounded-r-full transition-transform duration-[660ms] [transition-timing-function:cubic-bezier(0.65,0,0.35,1)];" style={{ transform: `translateX(-${100 - value}%)` }} />
		</Progress.Root>
	);
};
